import { render, staticRenderFns } from "./VerifyNew.vue?vue&type=template&id=73c759c3&"
import script from "./VerifyNew.vue?vue&type=script&lang=js&"
export * from "./VerifyNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports